import { render, staticRenderFns } from "./setupPassword.vue?vue&type=template&id=49ba11ce&scoped=true&"
import script from "./setupPassword.vue?vue&type=script&lang=ts&"
export * from "./setupPassword.vue?vue&type=script&lang=ts&"
import style0 from "./setupPassword.vue?vue&type=style&index=0&id=49ba11ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ba11ce",
  null
  
)

export default component.exports